module.exports = __webpack_public_path__ + "assets/wedodevelopment.5358e0cdfbd8d88960fcc73b2c876092.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/wedodevelopment.png
 ** module id = 375
 ** module chunks = 0
 **/